module.exports = __webpack_public_path__ + "img/MenuButton_NT.29c0b94e.png";